'use strict';


'kiwi public';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _Html = require('@/libs/renderers/Html');

var _Html2 = _interopRequireDefault(_Html);

var _MessageParser = require('@/libs/MessageParser');

var _MessageParser2 = _interopRequireDefault(_MessageParser);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    props: ['network'],
    data: function data() {
        return {
            sidebarOpen: false,
            page: 0,
            page_size: 200,
            search: '',
            last_updated: 0
        };
    },
    computed: {
        noResults: function noResults() {
            return this.listState === 'updated' && this.filteredList.length === 0;
        },
        isLoading: function isLoading() {
            return this.listState === 'updating';
        },
        listState: function listState() {
            return this.network.channel_list_state;
        },
        list: function list() {
            return this.network.channel_list || [];
        },
        filteredList: function filteredList() {
            var _this = this;

            var list = [];

            if (this.search.length <= 2) {
                list = this.list;
            } else {
                list = this.list.filter(function (channel) {
                    var found = false;
                    if (channel.channel.toLowerCase().indexOf(_this.search) > -1) {
                        found = true;
                    }
                    if (channel.topic.toLowerCase().indexOf(_this.search) > -1) {
                        found = true;
                    }
                    return found;
                });
            }

            return _lodash2.default.sortBy(list, 'num_users').reverse();
        },
        paginated: function paginated() {
            var offset = this.page * this.page_size;
            var list = this.filteredList;
            var channels = [];
            for (var i = offset; i < offset + this.page_size; i++) {
                if (list[i]) {
                    channels.push(list[i]);
                }
            }

            return channels;
        },
        maxPages: function maxPages() {
            return Math.floor(this.filteredList.length / this.page_size);
        },
        canGoForward: function canGoForward() {
            return this.page * this.page_size >= this.filteredList.length;
        },
        canGoBackward: function canGoBackward() {
            return this.page > 0;
        }
    },
    watch: {
        search: function search() {
            this.page = 0;
        }
    },
    methods: {
        nextPage: function nextPage() {
            if (this.page < this.maxPages) {
                this.page++;
            }
        },
        prevPage: function prevPage() {
            if (this.page > 0) {
                this.page--;
            }
        },
        maybeUpdateList: function maybeUpdateList() {
            if (this.listState !== 'updating') {
                this.network.ircClient.raw('LIST');
            }
        },
        formatAndTrimTopic: function formatAndTrimTopic(rawTopic) {
            var showModes = this.$state.setting('showChanlistModes');

            var topic = showModes ? rawTopic : rawTopic.replace(/^\[([^\]]+)\] ?/, '');
            var blocks = (0, _MessageParser2.default)(topic, { extras: false });
            var content = (0, _Html2.default)(blocks);
            return content;
        },
        joinChannel: function joinChannel(channelName) {
            this.$state.addBuffer(this.network.id, channelName);
            this.network.ircClient.join(channelName);
        }
    }
};
window._kiwi_exports = window._kiwi_exports || {};
if(!window._kiwi_exports["components"]) window._kiwi_exports["components"] = {};
window._kiwi_exports["components"]["ChannelList"]
window._kiwi_exports.components.ChannelList = exports.default ? exports.default : exports;



//////////////////
// WEBPACK FOOTER
// ./build/exports-loader.js!./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/ChannelList.vue
// module id = bkMh
// module chunks = 1